import { IS_PROD } from "../api/client"

//FIREBASE
const config = {
    apiKey: "AIzaSyA1G3fDRI0ZkefxrAiWcT20n_ePl1_SY38",
    authDomain: "qmo-australia-dev.firebaseapp.com",
    databaseURL: "https://qmo-australia-dev.firebaseio.com",
    projectId: "qmo-australia-dev",
    storageBucket: "qmo-australia-dev.appspot.com",
    messagingSenderId: "317129450745",
}

const configProd = {
    apiKey: "AIzaSyCNou07-yIL8s2PLcArWARZGGFxyeyJ_o8",
    authDomain: "peaceful-berm-266823.firebaseapp.com",
    databaseURL: "https://peaceful-berm-266823.firebaseio.com",
    projectId: "peaceful-berm-266823",
    storageBucket: "peaceful-berm-266823.appspot.com",
    messagingSenderId: "197478184852",
}

export const firebaseConfig = (IS_PROD ? configProd : config)

//STRIPE
export const stripePublishKey = (IS_PROD ? "pk_test_i0okOZmuj7K2wd1YjhoXpN2y00lEu4qwUQ" : "pk_test_i0okOZmuj7K2wd1YjhoXpN2y00lEu4qwUQ")
